module.exports = __webpack_public_path__ + "img/sec3_slide1_mobile.a70096ff.jpg";